// extracted by mini-css-extract-plugin
export var blue = "Button-module--blue--u8PIg";
export var blueInvert = "Button-module--blueInvert--h7-CG";
export var large = "Button-module--large--RlCLh";
export var red = "Button-module--red--YD7MK";
export var redInvert = "Button-module--redInvert--8yKT-";
export var root = "Button-module--root--+5JQU";
export var small = "Button-module--small--cV1XV";
export var white = "Button-module--white--Wciqa";